<template>
  <div ref="triggerRef">
    <VersionItem
      v-if="version"
      :version="version"
      :project-name="projectName"
      :is-latest="true"
      :is-opened="isOpen"
      :show-toggle="true"
      data-test="latest-version"
      @toggleVersions="togglePopover"
    />
    <div
      v-else
      class="flex min-h-[56px] flex-row items-center gap-sm rounded-sm bg-surface-2 px-md py-sm text-on-surface dark:bg-surface-2-dark dark:text-on-surface-dark typography-caption-regular"
      data-test="latest-version-loading"
    >
      <OrIconButtonV3
        :icon="isOpen ? 'expand_more' : 'chevron_right'"
        data-test="card-content"
        @click.stop="togglePopover"
      />
      <span>{{ $t('version') }}</span>
      <OrLoaderV3
        v-if="isLoading"
        variant="circular"
      />
    </div>
  </div>

  <OrPopoverV3
    :trigger="triggerRef"
    :is-open="isOpen"
    placement="bottom-start"
    :offset="0"
    :full-width="true"
    :disable-default-styles="true"
    @close="isOpen = false"
    @open="isOpen = true"
  >
    <div
      class="overflow-hidden rounded-b-sm bg-surface-2 dark:bg-surface-2-dark"
      data-test="versions-list"
    >
      <div
        v-if="isLoading"
        class="flex justify-center p-lg"
      >
        <OrLoaderV3 variant="circular" />
      </div>
      <div
        v-else
        class="max-h-[240px] overflow-y-auto"
      >
        <div
          v-if="!versions.length"
          class="px-md py-md text-center text-on-surface-variant dark:text-on-surface-variant-dark typography-caption-regular"
          data-test="versions-empty"
        >
          {{ $t('noOtherVersions') }}
        </div>
        <VersionItem
          v-for="item in versions"
          :key="item"
          :version="item"
          :project-name="projectName"
          :is-latest="latestVersion === item"
          :show-toggle="false"
          :show-delete="false"
          :show-leading-icon="false"
          :is-rounded="false"
          @versionDelete="emit('versionDelete', item)"
        />
      </div>
    </div>
  </OrPopoverV3>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { OrIconButtonV3, OrLoaderV3, OrPopoverV3 } from '@onereach/ui-components';
import VersionItem from './VersionItem.vue';

const props = withDefaults(defineProps<{
  version?: string;
  projectName: string;
  versions?: string[];
  latestVersion?: string | null;
  isLoading?: boolean;
}>(), {
  version: '',
  versions: () => [],
  latestVersion: null,
  isLoading: false,
});

const emit = defineEmits<{
  (event: 'open'): void;
  (event: 'versionDelete', version: string): void;
}>();

const triggerRef = ref<HTMLElement>();
const isOpen = ref(false);

function togglePopover() {
  isOpen.value = !isOpen.value;
  if (isOpen.value) {
    emit('open');
  }
}
</script>
